import React from "react"
import Image from "../image";

const TwoByOneImageBlock = (props) => {

    const imageSrc = props.src ? props.src : '';

    let template = (<> </>);
    if (imageSrc) {
        template = (<>
            <li className="column is-12-mobile is-6-tablet is-8-desktop is-6-widescreen">
                <div>
                    <div className="img-tile-image">
                        <Image
                            sizes="(min-width: 1216px) 612px, (min-width: 1024px) 704px, (min-width: 768px) 900px, calc(200vw - 5rem)"
                            height={"100%"}
                            crop={true}
                            url={imageSrc}
                            aspectRatio="4:2.81"
                            focalPoint={""}
                            altText={"alt-text"}
                        />
                    </div>
                </div>
            </li>
        </>)
    }
    return template;
}

export default TwoByOneImageBlock;


